import { Heading, List } from '@chakra-ui/react';
import {
  RecordShareEngagement,
  RecordShareEngagementActionEnglishDisplay,
} from '@monetize/types/app';
import { useMemo } from 'react';
import { MFlex, MText } from '../../Monetize';
import { DateDisplay } from '../../Monetize/DateDisplay';

const MAX_VISIBLE_ENGAGEMENTS = 5;

interface QuoteShareActivityProps {
  engagements?: RecordShareEngagement[];
}

/**
 * Allow users to create a Quote Share, view/copy an existing share link,
 * and view external activity.
 */
export const QuoteShareActivity = ({
  engagements,
}: QuoteShareActivityProps) => {
  const recentEngagements = useMemo(
    () =>
      [...(engagements ?? [])]
        .sort(
          (engagementA, engagementB) =>
            engagementB.timestamp.getTime() - engagementA.timestamp.getTime(),
        )
        .slice(0, MAX_VISIBLE_ENGAGEMENTS),
    [engagements],
  );

  return (
    <>
      <Heading as="h4" fontWeight={500} fontSize="sm" mt={4} mb={2}>
        Link Activity
      </Heading>
      {recentEngagements.length > 0 ? (
        // `plain`: v2's `List` had no bullets. Its items are flex rows, so
        // the row needs `w="full"` to keep the date pushed to the right.
        <List.Root variant="plain" gap={1}>
          {recentEngagements.map((item) => (
            <List.Item key={item.id}>
              <MFlex justifyContent="space-between" w="full">
                <MText>
                  {RecordShareEngagementActionEnglishDisplay[item.action](
                    'Quote',
                  )}
                </MText>
                <DateDisplay
                  date={item.timestamp}
                  timezoneConfigKey="userTimezone"
                />
              </MFlex>
            </List.Item>
          ))}
        </List.Root>
      ) : (
        <MText fontStyle="italic">This link has not yet been viewed</MText>
      )}
    </>
  );
};
